import { apiDelete, apiGet, apiPatch, apiPost } from "./api";

export async function createOrder(payload) {
  return apiPost("/orders/create/", payload);
}

export async function getOrderById(orderId) {
  return apiGet(`/orders/${orderId}/`);
}

export async function getAdminOrders(params = {}) {
  return apiGet("/orders/", params);
}

export async function updateOrderStatus(orderId, payload) {
  return apiPatch(`/orders/${orderId}/status/`, payload);
}

export async function deleteOrder(orderId) {
  return apiDelete(`/orders/${orderId}/delete/`);
}
